import { IconButton } from '@mui/material';
import { ICommonButtonProps } from '../../../types/button';
import EditIcon from '@mui/icons-material/Edit';

export const EditButton = ({ onClick }: ICommonButtonProps) => {
  return (
    <>
      <IconButton
        onClick={() => {
          onClick();
        }}
      >
        <EditIcon fontSize="small" />
      </IconButton>
    </>
  );
};
